import React from 'react'

import Stack from 'react-bootstrap/Stack'
import Button from 'react-bootstrap/Button'

import { SeatMapNavigation } from '../../../../SeatMapNavigation'
import { Spinner } from '../../../../LoadingContainer/Spinner'

import './navigation.scss'

export default function Navigation({
  event,
  isEventPublished,
  hasEventEnded,
  isSaved,
  configuration,
  templateName,
  activeTab,
  setActiveTab,
  unassignedSeats,
  handleShowResetConfiguration,
  handleShowSave,
  handlePrint,
  handleLeave,
  handleSave,
  isSaving,
  isMapDisabled,
  hasUnsavedChanges,
  onStartTutorial,
}) {
  const handleClick = () => {
    setActiveTab('inventory')
  }

  const getButton = () => (
    <Button
      onClick={handleSave}
      disabled={isMapDisabled || isSaving || !hasUnsavedChanges}
      data-seatmap-tour="save-btn"
    >
      {isSaving ? <Spinner /> : 'Save'}
    </Button>
  )

  return (
    <SeatMapNavigation
      event={event}
      configuration={configuration}
      templateName={templateName}
      isDisabled={isEventPublished || hasEventEnded}
      isSaveDisabled={isEventPublished || hasEventEnded}
      handleLeave={handleLeave}
      handleShowReset={handleShowResetConfiguration}
      handleShowSave={handleShowSave}
      handlePrint={activeTab === 'scaling' ? handlePrint : undefined}
      onStartTutorial={onStartTutorial}
      getButton={getButton}
    >
      <Stack
        direction="horizontal"
        as="ul"
        className="gap-5 tabs small flex-grow-1 justify-content-center"
        data-seatmap-tour="tabs"
      >
        <li className={`tab ${activeTab === 'scaling' ? 'active' : ''}`}>
          <Button
            variant="link"
            className="text-reset"
            onClick={() => setActiveTab('scaling')}
          >
            Scaling
          </Button>
        </li>
        <li className={`tab ${activeTab === 'inventory' ? 'active' : ''}`}>
          <Button
            variant="link"
            className={`text-reset ${
              unassignedSeats && unassignedSeats?.seats.length > 0
                ? 'btn-link-disabled btn-link-disabled--with-cursor'
                : ''
            }`}
            {...(unassignedSeats &&
              unassignedSeats?.seats.length === 0 && {
                onClick: handleClick,
              })}
          >
            Inventory
          </Button>
        </li>
      </Stack>
    </SeatMapNavigation>
  )
}
